// extracted by mini-css-extract-plugin
export default {"segmentNav":"segmentNav__Be0wxE"};